import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProfilePicture = styled.img`
  width: 140px;
  height: 140px;
  border-radius: 50%;
  border: 2px solid #434343;
`;
